import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
import Cookies from 'js-cookie'
import './permission'

import { i18n } from "./i18n";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import locale from 'element-ui/lib/locale/lang/zh-CN'

import '@/assets/css/flex-move.css'
import '@/assets/css/theme.scss'
import '@/assets/css/element-variables.scss'
Vue.use(ElementUI, { locale })

import BackNav from '@/components/backNav'
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
Vue.component('BackNav', BackNav)
Vue.component('ImagePreview', ImagePreview)
// Vue.use(ElementUI,{
//   size:Cookies.get('size') || 'small',
//   i18n:(key,value)=>i18n.t(key,value)
// })

new Vue({
  router,
  store,
	i18n,
  render: h => h(App)
}).$mount('#app')
